'use client';

import { FC } from 'react';

import { useProfileContext } from '@/src/providers';

import { AllToolsPortal } from './_all_tools';
import { AnimateProfilePhotoPortal } from './_animate_profile_photo';
import { AnyImageToVideoPortal } from './_any_image_to_video';
import { ExampleImagePortal } from './_example_image';
import { GenerateImagePortal } from './_generate_image';
import { GenerateInpaintPortal } from './_generate_inpaint';
import { GeneratePhotoByPhotoPortal } from './_generate_photo_by_photo';
import { GodModePortal } from './_god_mode';
import { InpaintModePortal } from './_inpaint_mode';
import { MySubscribersPortal } from './_my_subscribers';
import { MySubscriptionsPortal } from './_my_subscriptions';
import { ProfilePhotoToolsPortal } from './_profile_photo_tools';
import { RepeatFeedPhotoPortal } from './_repeat_feed_photo';
import { SeeAllImagesPortal } from './_see_all_images';
import { SeeAllTrendingPortal } from './_see_all_trending';
import { TopUpBalancePortal } from './_top_up_balance';
import { UserSubscribersPortal } from './_user_subscribers';
import { UserSubscriptionsPortal } from './_user_subscriptions';
import { SeeAllStorylineItemsPortal } from './_see_all_storyline';

export const Portals: FC = () => {
  const profile = useProfileContext();

  if (!profile) {
    return;
  }

  return (
    <>
      <SeeAllImagesPortal />
      <SeeAllTrendingPortal />
      <TopUpBalancePortal />
      <GenerateImagePortal />
      <ExampleImagePortal />
      <GeneratePhotoByPhotoPortal />
      <GenerateInpaintPortal />
      <InpaintModePortal />
      <GodModePortal />
      <AnyImageToVideoPortal />
      <AllToolsPortal />
      <ProfilePhotoToolsPortal />
      <AnimateProfilePhotoPortal />
      <RepeatFeedPhotoPortal />
      <MySubscribersPortal />
      <MySubscriptionsPortal />
      <UserSubscribersPortal />
      <UserSubscriptionsPortal />
      <SeeAllStorylineItemsPortal />
    </>
  );
};
